<svg
    viewbox="0 0 512 512"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
    d="M353.047 256L498.604 110.444C516.465 92.5818 516.465 63.6218
    498.604 45.7455L466.255 13.3964C448.393 -4.46545 419.433 -4.46545
    401.556 13.3964L256 158.953L110.444 13.3964C92.5818 -4.46545 63.6218
    -4.46545 45.7455 13.3964L13.3964 45.7455C-4.46545 63.6073 -4.46545
    92.5673 13.3964 110.444L158.953 256L13.3964 401.556C-4.46545 419.418
    -4.46545 448.378 13.3964 466.255L45.7455 498.604C63.6073 516.465
    92.5818 516.465 110.444 498.604L256 353.047L401.556 498.604C419.418
    516.465 448.393 516.465 466.255 498.604L498.604 466.255C516.465
    448.393 516.465 419.433 498.604 401.556L353.047 256Z" />
</svg>